<template>
  <div class="rule-form-step rule-form-step--scaling-up rule-form-step--scaling-up--step-1 flex max-w-4xl flex-col gap-5 py-5">
    <name-block
      :entity="entity"
      :description="tr('This will be the name of your currently created automation as well as the name of the campaign. The automation and campaign name will help you identify and easily manage the different automations you\'ve created.')"
      :disabled="$parent.readonlyMode"
    />

    <notifiable-users-block :entity="entity" :disabled="$parent.readonlyMode" />
    <activity-management-block :entity="entity" :disabled="$parent.readonlyMode" />

    <form-block :title="tr('AI Assist')">
      <label :class="[ 'flex w-fit items-center gap-2 text-sm text-foreground', $parent.readonlyMode ? 'cursor-not-allowed' : 'cursor-pointer' ]">
        <ui-checkbox
          :model-value="!!entity.settings.dont_scale_expired_ads"
          :disabled="$parent.readonlyMode"
          @update:model-value="(value) => entity.settings.dont_scale_expired_ads = value"
        />
        {{ tr('Do not scaling up ads with expired content') }}
        <info-popup>
          <div v-html="tr('Check the ad copy expiration date by Infinite∞Ai')" />
        </info-popup>
      </label>
    </form-block>

    <brand-block
      :entity="entity"
      :disabled="$parent.readonlyMode || !entity.isNew"
    />

    <operation-area-block
      :entity="entity"
      :disabled="$parent.readonlyMode"
      :disabled-option-message="tr('In the case of an upscaling task, only Start Automations with the same goal (campaign objective) and using the same Special advertising categories can be selected at the same time.')"
    />

    <form-block
      :title="tr('Filters')"
      :description='tr("You can set different filters to determine the conditions under which the ads should stop or scaling up. You can add multiple conditions to an ad by clicking on the \"+\" sign, and you can connect them with the \"and\" or \"or\" options.")'
    >
      <condition-group
        v-model="entity.conditions"
        :action="entity.action"
        :platforms="entity.selectedSourcePlatforms"
        :ad-account="entity.selectedAdAccount"
        :disabled="!filterIsAvailable || $parent.readonlyMode"
      />
    </form-block>
  </div>
</template>

<script>
import { AD_CREATION_METHOD } from '@/consts.js';
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import InfoPopup from '@/ui/components/InfoPopup.vue';
import ActivityManagementBlock from '@/ui/components/RuleForm/Blocks/ActivityManagementBlock.vue';
import BrandBlock from '@/ui/components/RuleForm/Blocks/BrandBlock.vue';
import NameBlock from '@/ui/components/RuleForm/Blocks/NameBlock.vue';
import NotifiableUsersBlock from '@/ui/components/RuleForm/Blocks/NotifiableUsersBlock.vue';
import OperationAreaBlock from '@/ui/components/RuleForm/Blocks/OperationAreaBlock.vue';
import ConditionGroup from '@/ui/components/RuleForm/Condition/ConditionGroup.vue';

export default {
  name: 'ScalingUpRuleFormStep1',
  components: {
    InfoPopup,
    ActivityManagementBlock,
    BrandBlock,
    NameBlock,
    NotifiableUsersBlock,
    OperationAreaBlock,
    ConditionGroup,
  },
  mixins: [ RuleFormStepMixin ],
  computed: {
    hasSelectedSourceProfile() {
      return this.entity.source_profiles.filter(i => i.id).length !== 0;
    },
    filterIsAvailable() {
      const hasSelectedInputCampaign = this.entity.input_campaigns.map(i => i.id).filter(id => !!id).length !== 0;
      return this.entity.hasSelectedAdAccount && hasSelectedInputCampaign;
    },
  },
  watch: {
    'entity.input_campaigns'(val) {
      if (this.entity.isNew && val.length === 0) {
        this.entity.output_campaign.objective = null;
      }
      else if (val.length === 1) {
        if (!this.entity.output_campaign.objective) {
          this.entity.output_campaign.objective = val[0].objective;
        }

        if (val[0].objective === 'OUTCOME_ENGAGEMENT') {
          this.entity.settings.ad_creation_method = AD_CREATION_METHOD.POST_BOOST;
        }
      }
    },
  },
  methods:{
    validate() {
      if (!this.validateBlocks()) {
        return false;
      }

      if (!this.entity.isValidConditions) {
        this.error(this.tr('All Filter fields must be filled in!'));
        return false;
      }

      return true;
    },
  },
};
</script>
